import {Stack, Textarea, TextInput} from '@mantine/core'

import {formatPhoneInput} from 'src/lib/format-phone'

import {type ContactWriteInput} from './schemas'

export type ContactFieldErrors = {
    nameError?: string
    phoneError?: string
    emailError?: string
}

export function validateContact(contact: ContactWriteInput): ContactFieldErrors {
    const nameError = contact.name.trim() ? undefined : 'Contact name is required'
    const emailError =
        contact.email?.trim() && !/^\S+@\S+\.\S+$/.test(contact.email.trim())
            ? 'Invalid email address'
            : undefined
    return {nameError, emailError}
}

export type ContactFormFieldsProps = {
    draft: ContactWriteInput
    errors?: ContactFieldErrors
    onUpdate: (partial: Partial<ContactWriteInput>) => void
    /** Hide the internal-only description field (e.g. for driver-facing surfaces). */
    hideDescription?: boolean
}

export function ContactFormFields({
    draft,
    errors,
    onUpdate,
    hideDescription = false,
}: ContactFormFieldsProps) {
    return (
        <Stack gap="sm">
            <TextInput
                label="Name"
                value={draft.name}
                error={errors?.nameError}
                onChange={(event) => onUpdate({name: event.currentTarget.value})}
            />
            <TextInput
                label="Title"
                value={draft.title ?? ''}
                onChange={(event) => onUpdate({title: event.currentTarget.value})}
            />
            {hideDescription ? null : (
                <Textarea
                    label="Description"
                    description='Internal note (e.g. "Contact for billing")'
                    minRows={2}
                    value={draft.description ?? ''}
                    onChange={(event) => onUpdate({description: event.currentTarget.value})}
                />
            )}
            <TextInput
                label="Phone"
                value={draft.phone}
                error={errors?.phoneError}
                onChange={(event) => onUpdate({phone: formatPhoneInput(event.currentTarget.value)})}
            />
            <TextInput
                label="Email"
                value={draft.email ?? ''}
                error={errors?.emailError}
                onChange={(event) => onUpdate({email: event.currentTarget.value})}
            />
        </Stack>
    )
}
